import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Row } from "react-bootstrap";
import { post } from "../../../helpers/api_helper";
import { Spin } from "antd";
import {
  successMessage,
  errorMessage,
  capitalizeString,
  warningMessage,
  delete_RecordWithoutApi,
} from "../CommonFunctions";
import {
  POST_GetNDTCategoryDropDownListByCategoryType,
  POST_CameraInsert,
  POST_CameraUpdate,
  POST_GetCameraDetailByID,
} from "../../../helpers/url_helper";
import CustomSelect from "../../../CustomControls/CustomSelect";
import { SVGICON } from "../../../constant/theme";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import moment from "moment";

const AddCamera = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { PrimaryIdParam } = useParams();
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const [isotopeOptions, setIsotopeOptions] = useState([]);

  useEffect(() => {
    GetNDTCategoryDropDownListByCategoryTypeApi();
    if (PrimaryIdParam) {
      getCameraDetailByID();
    }
  }, []);

  const getCameraDetailByID = () => {
    setIsLoading(true);
    post(POST_GetCameraDetailByID, {
      CameraIDEncrypt: window.atob(PrimaryIdParam),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setValues({
            ...response,
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const GetNDTCategoryDropDownListByCategoryTypeApi = async () => {
    setIsLoading(true);
    await post(POST_GetNDTCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      NDTCategoryType: 5, // 5 is for Isotope
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setIsotopeOptions(
            response?.List?.map((x) => ({
              label: x.NDTCategoryName,
              value: x.NDTCategoryID,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const validationSchema = Yup.object().shape({
    ModelNo: Yup.string().trim().required("Model No is required field"),
    SerialNo: Yup.string().trim().required("Serial No is required field"),
    SourceSize: Yup.string().trim().required("Source Size is required field"),
    IsotopeID: Yup.string().trim().required("Isotope is required field"),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      CameraIDEncrypt: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
      IsotopeID: 0,
      Isotope: "",
      ModelNo: "",
      SerialNo: "",
      SourceSize: "",
      ListOfCamera: [],
      Remarks: "",
      actionFlag: 0, // 0 = Add,  1 = edit
    },
    validateOnBlur: false,
  });

  const {
    values: { ListOfCamera, actionFlag },
  } = formik;

  const handleValidSubmit = (values) => {
    if (
      values?.ListOfCamera?.filter((x) => x?.IsDeleted === false).length === 0
    ) {
      formik.setFieldError(
        "ListOfCamera",
        "Please fill all the above details of List Of Camera..."
      );
      formik.setFieldTouched("ListOfCamera", true);
      return;
    }

    setIsLoading(true);

    const payload = {
      ...values,
      ModelNo: values?.ModelNo,
      SourceSize: values?.SourceSize,
      SerialNo: values?.SerialNo,
      IsotopeID: values?.IsotopeID,
      ListOfCamera: values?.ListOfCamera?.map((item) => ({
        CameraIDEncrypt: item?.CameraIDEncrypt,
        CameraDetailsIDEncrypt: item?.CameraDetailsIDEncrypt,
        DateofLoading: item?.DateofLoading
          ? moment(item?.DateofLoading).format("YYYY-MM-DD").replace(/^\-/, "")
          : "",
        InitialActivity: item?.InitialActivity,
        PencilNo: item?.PencilNo,
        Remarks: item?.Remarks,
        IsDeleted: item?.IsDeleted,
      })),
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };
    post(PrimaryIdParam ? POST_CameraUpdate : POST_CameraInsert, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/camera");
          }, 1000);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };

  const setAddListOfCamera = () => {
    let cameraExists = false;
    const list = formik?.values?.ListOfCamera || [];

    const {
      DateofLoading,
      InitialActivity,
      PencilNo,
      Remarks,
      actionFlag,
      indx,
    } = formik.values;

    // Validation
    if (!DateofLoading) {
      formik.setFieldError("DateofLoading", "Date of Loading is required");
      formik.setFieldTouched("DateofLoading", true);
      return;
    }

    if (!InitialActivity) {
      formik.setFieldError("InitialActivity", "Initial Activity is required");
      formik.setFieldTouched("InitialActivity", true);
      return;
    }

    if (!PencilNo) {
      formik.setFieldError("PencilNo", "Pencil No is required");
      formik.setFieldTouched("PencilNo", true);
      return;
    }

    // Check if duplicate exists (ignore same index if editing)
    cameraExists = list.some((item, i) => {
      return (
        i !== indx &&
        new Date(item.DateofLoading).toLocaleString() ===
          new Date(DateofLoading).toLocaleString() &&
        item.InitialActivity?.trim() === InitialActivity?.trim() &&
        item.PencilNo?.trim().toLowerCase() === PencilNo?.trim().toLowerCase()
      );
    });

    if (cameraExists) {
      warningMessage("Camera entry already exists.");
      return;
    }

    // If editing
    if (actionFlag === 1 && indx > -1) {
      const updatedList = list.map((item, i) =>
        i === indx
          ? {
              ...item,
              DateofLoading,
              InitialActivity,
              PencilNo,
              Remarks,
              IsDeleted: false,
            }
          : item
      );
      formik.setFieldValue("ListOfCamera", updatedList);
    } else {
      // If adding new
      const newItem = {
        CameraIDEncrypt: "",
        CameraDetailsIDEncrypt: "",
        DateofLoading,
        InitialActivity,
        PencilNo,
        Remarks,
        IsDeleted: false,
      };
      formik.setFieldValue("ListOfCamera", [...list, newItem]);
    }
    // Clear form
    formik.setFieldValue("DateofLoading", "");
    formik.setFieldValue("InitialActivity", "");
    formik.setFieldValue("PencilNo", "");
    formik.setFieldValue("Remarks", "");
    formik.setFieldValue("indx", "");
    formik.setFieldValue("actionFlag", 0); // Reset to add mode
  };

  const deleteCameraList = (i) => {
    if (ListOfCamera[i]?.CameraDetailsIDEncrypt) {
      formik.setFieldValue(
        "ListOfCamera",
        ListOfCamera?.map((x, idx) => {
          if (idx == i) {
            return {
              ...x,
              IsDeleted: true,
            };
          } else {
            return { ...x };
          }
        })
      );
    } else {
      formik.setFieldValue(
        "ListOfCamera",
        ListOfCamera?.filter((x, idx) => idx != i)
      );
    }
    formik.setFieldValue("DateofLoading", "");
    formik.setFieldValue("InitialActivity", "");
    formik.setFieldValue("PencilNo", "");
    formik.setFieldValue("Remarks", "");
    formik.setFieldValue("indx", "");
    formik.setFieldValue("actionFlag", 0);
  };

  const editCameraList = (i) => {
    // alert(i);
    let editData = ListOfCamera?.filter((x, idx) => idx == i)[0];
    formik.setFieldValue("DateofLoading", new Date(editData?.DateofLoading));
    formik.setFieldValue("InitialActivity", editData.InitialActivity.trim());
    formik.setFieldValue("PencilNo", editData.PencilNo.trim());
    formik.setFieldValue("Remarks", editData.Remarks.trim());
    formik.setFieldValue("indx", i);
    formik.setFieldValue("actionFlag", 1); // 1 = edit
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">
                {PrimaryIdParam ? "Edit" : "Add"} Camera
              </h4>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0">
              <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                  <Row>
                    <Col lg={3}>
                      <Field
                        type="text"
                        label="Model No"
                        name="ModelNo"
                        placeholder={`Enter Model No`}
                        component={CustomInput}
                        maxLength={250}
                        required
                        autoFocus
                        onChange={(e) => {
                          formik.setFieldValue("ModelNo", capitalizeString(e));
                        }}
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        type="text"
                        label="Serial No"
                        name="SerialNo"
                        placeholder={`Enter Serial No`}
                        component={CustomInput}
                        maxLength={250}
                        required
                        autoFocus
                        onChange={(e) => {
                          formik.setFieldValue("SerialNo", capitalizeString(e));
                        }}
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        type="text"
                        label="Source Size"
                        name="SourceSize"
                        placeholder={`Enter Source Size`}
                        component={CustomInput}
                        maxLength={250}
                        required
                        autoFocus
                        onChange={(e) => {
                          formik.setFieldValue(
                            "SourceSize",
                            capitalizeString(e)
                          );
                        }}
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        label="Isotope"
                        name="IsotopeID"
                        placeholder={"Isotope"}
                        options={isotopeOptions}
                        component={CustomSelect}
                        isClearable={false}
                        // onChange={(e) => {
                        //   formik.setFieldValue("Isotope", e?.label ?? "");
                        //   formik.setFieldValue("IsotopeID", e?.value ?? 0);
                        // }}
                        required
                        isDisabled={PrimaryIdParam ? true : false}
                      />
                    </Col>
                  </Row>

                  <div
                    className="card-header"
                    style={{ padding: ".6rem 0rem" }}
                  >
                    <h4 className="card-title">Camera Detail</h4>
                  </div>
                  <Row>
                    <Col lg={9}>
                      <Row>
                        <Col lg={3} style={{ marginTop: "6px" }}>
                          <Field
                            label="Date of Loading"
                            name={"DateofLoading"}
                            placeholder={"Select Date of Loading"}
                            component={CustomFlatpickr}
                            options={{
                              altInput: true,
                              altFormat: "j-M-Y",
                              dateFormat: "d-m-Y",
                            }}
                            required
                          />
                        </Col>

                        <Col lg={3} style={{ marginTop: "6px" }}>
                          <Field
                            type="text"
                            label="Initial Activity"
                            name="InitialActivity"
                            placeholder={`Enter Initial Activity`}
                            component={CustomInput}
                            maxLength={250}
                            required
                            onChange={(e) => {
                              formik.setFieldValue(
                                "InitialActivity",
                                e.target.value
                              );
                            }}
                          />
                        </Col>

                        <Col lg={3} style={{ marginTop: "6px" }}>
                          <Field
                            type="text"
                            label="Pencil No."
                            name="PencilNo"
                            placeholder={`Enter Pencil No.`}
                            component={CustomInput}
                            maxLength={100}
                            required
                            onChange={(e) => {
                              formik.setFieldValue("PencilNo", e.target.value);
                            }}
                          />
                        </Col>

                        <Col lg={3} style={{ marginTop: "6px" }}>
                          <Field
                            type="text"
                            label="Remarks"
                            name="Remarks"
                            placeholder={`Enter Remarks`}
                            component={CustomInput}
                            maxLength={500}
                            onChange={(e) => {
                              formik.setFieldValue("Remarks", e.target.value);
                            }}
                          />
                        </Col>
                      </Row>
                    </Col>

                    <Col lg={3}>
                      <label style={{ marginTop: "28px" }}>
                        <button
                          type="button"
                          className="btn btn-outline-primary btn-sm"
                          onClick={(e) => {
                            setAddListOfCamera();
                          }}
                        >
                          {actionFlag == 1 ? "Update" : "Add"}
                        </button>
                      </label>
                    </Col>
                  </Row>

                  <Col lg={12}>
                    <div className="card-body" style={{ paddingLeft: 0 }}>
                      <ErrorMessage
                        name={"ListOfCamera"}
                        component="div"
                        className="invalid-feedback animated fadeInUp"
                        style={{ display: "block" }}
                      />
                      <div className="table-responsive active-projects style-1 shorting">
                        <div
                          id="ItemDetail-tbl_wrapper"
                          className="dataTables_wrapper table-responsive no-footer "
                          style={{ overflowY: "auto" }}
                        >
                          <table
                            id="ItemDetail-tbl"
                            className="table dataTable no-footer mb-0"
                          >
                            <thead className="fixedheader">
                              <tr>
                                <th width="3%"></th>
                                <th width="20%">Date of Loading</th>
                                <th width="20%">Initial Activity</th>
                                <th width="20%">Pencil No</th>
                                <th width="37%" style={{ textAlign: "left" }}>
                                  Remarks
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {ListOfCamera?.filter(
                                (x) => x.IsDeleted === false
                              ).length > 0 ? (
                                ListOfCamera?.map((item, indx) => (
                                  <tr
                                    key={indx}
                                    style={{
                                      display:
                                        item.IsDeleted === true ? "none" : "",
                                    }}
                                  >
                                    <td style={{ textAlign: "center" }}>
                                      <Link
                                        to="#"
                                        onClick={() => {
                                          editCameraList(indx);
                                        }}
                                        className="icon-box icon-box-md me-1"
                                        title="Edit"
                                      >
                                        {SVGICON.EditPrimary}
                                      </Link>

                                      <Link
                                        to="#"
                                        className="icon-box icon-box-md me-1"
                                        title="Delete"
                                        onClick={() => {
                                          delete_RecordWithoutApi(
                                            deleteCameraList,
                                            indx
                                          );
                                        }}
                                      >
                                        {SVGICON.DeleteDanger}
                                      </Link>
                                    </td>
                                    <td>
                                      {item.DateofLoading
                                        ? new Date(
                                            item.DateofLoading
                                          ).toLocaleDateString()
                                        : ""}
                                    </td>
                                    <td>{item.InitialActivity}</td>
                                    <td>{item.PencilNo}</td>
                                    <td style={{ textAlign: "left" }}>
                                      {item.Remarks}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={5} style={{ textAlign: "left" }}>
                                    <div>{"No Record Found..."}</div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </Col>

                  <hr className="mt-1 mb-2"></hr>
                  <button type="submit" className="btn btn-primary btn-sm me-2">
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={(e) => {
                      navigate(-1);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </Form>
              </FormikProvider>
            </div>
          </Spin>
        </div>
      </div>
    </>
  );
};

export default AddCamera;
